import { IAppState } from '../../common/state';
import { EComparisonStatus } from '../../types/newbuildingHeader';

export function getNewbuildingComparisonStatus({
  newbuildingInformation,
}: IAppState): EComparisonStatus | null | undefined {
  return newbuildingInformation?.comparisonStatus;
}
